module.exports = __webpack_public_path__ + "img/refferal-icon.921ab63c.svg";